export const HISTORICAL_SAMPLE_DIALOG_TITLE =
	"Sample date is before the current shift";
export const HISTORICAL_SAMPLE_WARNING_MESSAGE =
	"This inspection will not appear among the current shift's five recent inspections.";
